import { IDENTITY_PROVIDERS } from '../../configs';

export const getIdpLabelByValue = (value?: string): string | undefined => {
  if (!value) return undefined;
  const label = IDENTITY_PROVIDERS.find((option) => option.value === value)?.label;
  return label || value;
};
